module.exports = __webpack_public_path__ + "img/z_04_bastien-nvs.bc3a30ee.jpg";